import React, { memo } from 'react';
import cn from 'classnames';
import IconArrowRightBold from '@creditflowresearch/uilib/Icon/IconArrowRightBold';

import styles from './tableYearsNavArrows.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IProps {
  isDisabled: boolean,
  increaseTablePosition: () => void,
}

const TableYearsNavArrowsRight = ({ isDisabled = true, increaseTablePosition }:IProps) => {
  const wrapperClass = cn(
    styles.navTableArrow,
    {
      [styles.lastPosition]: isDisabled,
    },
  );

  return (
    <IconButton
      icon={ <IconArrowRightBold size={ 12 } /> }
      className={ wrapperClass }
      onClick={ increaseTablePosition }
      dataTest="tableYearsNavArrowIncreaseButton"
      ariaLabel="Show later years"
    />
  );
};

export default memo(TableYearsNavArrowsRight);
